module.exports = __webpack_public_path__ + "img/banner_1998.5014d28e.png";